import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../app/store'
import { goToQuestion } from '../store/endJourneySlice'

export const Header: React.FC = () => {
  const dispatch = useDispatch()
  const { currentQuestionIndex, questions } = useSelector(
    (state: RootState) => state.endJourney
  )
  const isLastQuestion = currentQuestionIndex === questions.length - 1

  const handleClose = () => {
    dispatch(goToQuestion(0))
  }

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="mx-auto px-4 sm:px-6 h-16 flex items-center">
        <div className="flex items-center gap-2 sm:gap-3">
          {/* Hupo Logo - using a circle as placeholder, replace with actual logo */}
          <div className="size-6 sm:size-8 flex items-center justify-center">
            <img
              src="/logos/icon/orange/icon.svg"
              alt="Hupo Logo"
              className="w-full h-full"
            />
          </div>
          <h1 className="font-bold text-lg sm:text-xl text-gray-900">
            Hupo Perspectives
          </h1>
        </div>
        {currentQuestionIndex > 0 && !isLastQuestion && (
          <button onClick={handleClose} className="ml-auto">
            <XMarkIcon className="w-5 h-5 sm:w-6 sm:h-6 text-gray-600" />
          </button>
        )}
      </div>
    </header>
  )
}
